import type { RawProduct } from '~/types/searchTypes'

export default function (response: RawProduct[]): RawProduct[] {
  return response.filter((value: RawProduct, index) => {
    return index === response.findIndex((obj: RawProduct) => obj.quote_slug === value.quote_slug)
  })
}
